import { render } from "./PublicHeader.vue?vue&type=template&id=9c2c79c8&scoped=true&ts=true"
import script from "./PublicHeader.vue?vue&type=script&lang=ts"
export * from "./PublicHeader.vue?vue&type=script&lang=ts"

import "./PublicHeader.vue?vue&type=style&index=0&id=9c2c79c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cpinkney\\Documents\\Dev\\GroupTrips3\\grouptrips-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c2c79c8"]])

export default __exports__